export class HistoricoNavegacao {
    telaAcessada: string | null;

    constructor(telaAcessada: string | null) {
        this.telaAcessada = telaAcessada;
    }

}